import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
// import { Http, Headers } from '@angular/http';
// import 'rxjs/add/operator/map'
// import * as constants from '../constants/app.constant'; // 사용자 정의 상수

@Injectable()
export class TimerService {
    constructor(
        private http: HttpService
    ) {
    }
    gameTimer() {
        // const Proto = () => {};
        function Proto() {}
        Proto.prototype.stopTimer = () => {
            if (Proto.prototype.intervalId) {
                clearInterval(Proto.prototype.intervalId);
            }
        };

        Proto.prototype.countdownStart = (nowDateTime: any, game: string, callback: (body: any) => void) => { // 5분게임 타이머
            let startTime: any;
            let gameterm: number;

            const setNowDateTime = (ndTime: any, g: string) => { // 현재 시간을 세팅한다. 서버 시간으로 세팅
                switch (g) {
                    case 'ladder':
                        startTime = new Date(Date.parse(ndTime) - 10000); // 10초를 뒤로 당긴다.
                        gameterm = 5;
                        break;
                    case 'powerball':
                    case 'powerLadder':
                        startTime = new Date(Date.parse(ndTime) + 124000); // 2분뒤를 뒤로 당긴다.(3,8,13,18,23,28,33,38,43,48,53,58)
                        gameterm = 5;
                        break;
                    case 'dari':
                        startTime = new Date(Date.parse(ndTime) - 10000); // 10초를 뒤로 당긴다 (다리 동일)
                        gameterm = 3;
                        break;
                }
            };

            setNowDateTime(nowDateTime, game);

            const checkTime = (i: number) => { //
                let rtn = i.toString();
                if (i < 10) {
                    rtn = '0' + i;
                }  // add zero in front of numbers < 10
                return rtn;
            };

            const getRound = () => {
                const H = startTime.getHours();
                const i = startTime.getMinutes();
                const s = startTime.getSeconds();

                const timer = H * 60 * 60 + i * 60 + s;
                const curRound =  Math.ceil(timer / (60 * gameterm));

                return curRound;
            };

            const countdownHumanreadable = () => {
                const obj: any = {};

                obj.Y = startTime.getFullYear();
                obj.m = startTime.getMonth();
                obj.d = startTime.getDate();
                obj.H = startTime.getHours();
                obj.i = startTime.getMinutes();
                obj.s = startTime.getSeconds();

                obj.i = checkTime(obj.i);
                obj.s = checkTime(obj.s);
                obj.m = checkTime(obj.m + 1);

                // calculate remain time
                const passSeconds = startTime.getTime() % (60 * gameterm * 1000);
                const countdownSeconds = Math.ceil(((60 * gameterm * 1000) - passSeconds) / 1000);
                obj.countdown_ii = Math.floor(countdownSeconds / 60);
                obj.countdown_ss = countdownSeconds % 60;
                return obj;
            };

            const displayTimer = (ack: any) => {

                const obj = countdownHumanreadable();
                // 하단은 좌츠 출력용
                obj.remainsecond = obj.countdown_ii * 60 + obj.countdown_ss;
                obj.next_no = getRound();

                if (ack) { // 이후 되도록 callback을 이용하여 함수처리
                    callback({next_no: obj.next_no, countdown_ii: obj.countdown_ii, countdown_ss: obj.countdown_ss, remainsecond: obj.remainsecond});
                }
            };


            const synctime = () => {
                this.http.get({url: 'synctime'}).then((response) => {
                    if (response.code === '000') { // if invalid session then delete current info
                        setNowDateTime(response.nowTime, game);
                    } else {
                        console.error('Error synctime');
                    }
                });
            };

            Proto.prototype.intervalId = setInterval(() => {
                startTime = new Date(Date.parse(startTime) + 1000); // 시간을 1초식 올린다.

                const H = startTime.getHours();
                const i = startTime.getMinutes();
                const s = startTime.getSeconds();
                const timer = H * 60 * 60 + i * 60 + s;

                if (timer % 60 === 0) {
                    synctime(); // 시간을 동기화 시킨다.
                }
                displayTimer(callback);
            }, 1000);
        };

        return {
            getInstance: () => {
                return new Proto();
            }
        };

    }
}
